import React, { useState, useRef } from 'react';
import { Card, Header, Form as BaseForm, Input, withDefaultUseForm, Button } from '@optic-delight/ui-framework';
import 'react-datepicker/dist/react-datepicker.min.css';
import { Row, Col, Overlay, Tooltip } from 'react-bootstrap';
import './vault.css';
import { generateRandomString, maxChar250 } from '../utilities/utilities';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const BaseForms = withDefaultUseForm(BaseForm);

// Passcode Verification Page
const PasscodeVerification = () => {
	const [newSecret, setNewSecret] = useState(null);
	const [newSecretGenerated, setNewSecretGenerated] = useState(false);
	const [passcode, setPasscode] = useState(null);
	const [passcodeEntered, setPasscodeEntered] = useState(false);
	const [show, setShow] = useState(false);
	const target = useRef(null);

	const copyToClipboard = () => {
		// TODO
	};

	const onSubmit = () => {
		// TODO
	};

	const changePasscode = event => {
		let passcode = event.target.value;
		setPasscode(passcode);
		setPasscodeEntered(true);
	};

	const generateRandomClientSecret = () => {
		let randomString = generateRandomString();
		setNewSecret(randomString);
		setNewSecretGenerated(true);
	};

	return (
		<div data-testid="passcodeVerification" className="Vault">
			<BaseForms onSubmit={onSubmit} noValidate="noValidate">
				<Card>
					<Card.Body>
						<Header className="py-4" as="h3">
							Verify Passcode
						</Header>

						<Input
							label="Passcode"
							id="passcode"
							name="passcode"
							onChange={changePasscode}
							value={passcode}
							required
							validators={[
								{
									name: 'maxChar250',
									validate: maxChar250,
									message: 'Must be 250 characters or less.'
								}
							]}
						/>
						<Row>
							<Col md={9}>
								<Input
									label="New Secret"
									id="newSecret"
									name="newSecret"
									helptext="Click Generate button to get auto generated value"
									value={newSecret}
									type={'text'}
									required
									disabled
								/>
							</Col>
							<Col md={3} className="pt-3 mt-3">
								<Button disabled={newSecretGenerated} variant="default" onClick={generateRandomClientSecret}>
									Generate
								</Button>
							</Col>
						</Row>
						<CopyToClipboard text={newSecret} onCopy={copyToClipboard}>
							<Button disabled={!newSecretGenerated} ref={target} onClick={() => setShow(!show)}>
								Copy secret to clipboard
							</Button>
						</CopyToClipboard>
						<Overlay target={target.current} show={show} placement="bottom">
							{props => (
								<Tooltip id="overlay-example" {...props}>
									Copied!
								</Tooltip>
							)}
						</Overlay>
					</Card.Body>
					<Card.Footer>
						<Row className="justify-content-end mx-3 pb-5">
							<Col md="auto">
								<Button type="submit" disabled={!passcodeEntered || !newSecretGenerated} variant="primary">
									Save
								</Button>
							</Col>
						</Row>
					</Card.Footer>
				</Card>
			</BaseForms>
		</div>
	);
};

export default PasscodeVerification;
